import { useContext, useEffect } from "react"
import styles from "./index.module.scss"
import { GenerateContext } from "../../../hooks/GenerateContext"
import { GENERATE_MODE, IMAGE_TYPE } from "@utils/CONST"
import Iconfont from '@utils/Iconfont';
import { message, Tooltip } from 'antd';

const GenerateMode = (props) => {
    const {
        no1MultiAngleImage,
        generateMode, setGenerateMode
    } = useContext(GenerateContext)
    const { imageType } = props

    const items = [{
        value: GENERATE_MODE.STD,
        title: "标准模式",
        content: "生成速度更快",
        icon: <Iconfont type="icon-stdOutlined" />,
        iconActive: <Iconfont type="icon-stdFilled" />,
    }, {
        value: GENERATE_MODE.HQ,
        title: "高品质模式",
        content: "生成效果更好",
        icon: <Iconfont type="icon-hdOutlined" />,
        iconActive: <Iconfont type="icon-hdFilled" />,
        // 限免
        // isLimit: true,
    }]

    useEffect(() => {
        if (imageType == IMAGE_TYPE.IMAGE_TO_VIDEO && no1MultiAngleImage) {
            setGenerateMode(GENERATE_MODE.HQ)
        }
    }, [imageType, no1MultiAngleImage])

    return (
        <div className={styles.Container}>
            <p className={styles.Title}>生成模式</p>
            <div className={styles.PickerContent}>
                {
                    items.map(item => {
                        const disabledStd = imageType == IMAGE_TYPE.IMAGE_TO_VIDEO && no1MultiAngleImage && item.value == GENERATE_MODE.STD

                        if (disabledStd) {
                            return (
                                <Tooltip key={item.value} title="首尾帧生成视频仅支持高品质模式！" placement="top">
                                    <div
                                        className={`${styles.PickerItem} ${item.isLimit && styles.isLimit} ${generateMode == item.value && styles.actived}`}
                                        onClick={() => {
                                            message.warning("首尾帧生成视频仅支持高品质模式！", 5)
                                        }}
                                    >
                                        <div className={styles.Title}>
                                            {generateMode == item.value ? item.iconActive : item.icon}
                                            <span>{item.title}</span>
                                        </div>
                                        <span className={styles.Content}>{item.content}</span>
                                    </div>
                                </Tooltip>
                            )
                        }

                        return (
                            <div
                                key={item.value}
                                className={`${styles.PickerItem} ${item.isLimit && styles.isLimit} ${generateMode == item.value && styles.actived}`}
                                onClick={() => setGenerateMode(item.value)}
                            >
                                <div className={styles.Title}>
                                    {generateMode == item.value ? item.iconActive : item.icon}
                                    <span>{item.title}</span>
                                </div>
                                <span className={styles.Content}>{item.content}</span>
                            </div>
                        )
                    })
                }
            </div>
        </div>
    )
}

export default GenerateMode